















































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { SearchCondition } from '@/modules/chat';
import { Chat } from '@/models/chatResponse';
import { UserTypes } from '@/enums/userTypes';
import { ReadTypes, getReadTypeName } from '@/enums/readTypes';
import { FunctionTypes } from '@/enums/functionTypes';
import AvaivaledVue from '@/components/avaivaled.vue';
import StudentSingleSelectDialog,
  {SubmitArgs as StudentSelectedArgs} from '@/components/student/studentSingleSelectDialog.vue';

@Component({
  components: {
    'student-single-select-dialog': StudentSingleSelectDialog
  }
})
export default class ChatList extends AvaivaledVue {
  private ReadTypes = ReadTypes;
  private getReadTypeName = getReadTypeName;
  private showSearchCondition = true;

  private studentSelectVisible = false;

  @Prop() private searchCondition: string;

  @Watch('searchCondition')
  private changeSearchCondition() {
    this.setSearchCondition();
    this.loadData();
  }

  get loading(): boolean {
    return this.$store.state.chat.loading;
  }

  get userRole(): UserTypes {
    return this.$store.getters['auth/userType'];
  }

  get countAll(): number {
    if (this.$store.state.chat.countAll === 0) {
      return 1;
    } else {
      return this.$store.state.chat.countAll;
    }
  }

  get chatList(): Chat[] {
    return this.$store.state.chat.chatList;
  }

  get condition(): SearchCondition {
    return this.$store.state.chat.searchCondition;
  }

  get accountId(): string {
    return this.$store.getters['auth/accountId'];
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  private mounted() {
    this.setSearchCondition();
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private created() {
    this.pageBackCheck(FunctionTypes.Chat);
  }

  private setSearchCondition() {
    if (!!this.searchCondition) {
      const condition = JSON.parse(this.searchCondition) as SearchCondition;
      this.condition.readType = condition.readType;
      this.condition.dateFrom = condition.dateFrom;
      this.condition.dateTo = condition.dateTo;
      this.condition.ownOnly = condition.ownOnly;
      this.condition.keyWord = condition.keyWord;
      this.condition.page = 1;
      this.condition.sort = condition.sort;
    }
  }

  private loadData() {
    this.$store.dispatch('chat/searchChatList', this.condition);
  }

  private getRowNumber(index: number) {
    return this.condition.perPage * (this.condition.page - 1) + index + 1;
  }

  private updateDateFormatter(row: Chat) {
    if (!row.updateDate) {
      return '';
    } else {
      return (this as any).$moment(row.updateDate).format('YYYY/MM/DD H:mm');
    }
  }

  private onChangeCondition() {
    this.condition.page = 1;
    this.loadData();
  }

  private onChangePage() {
    this.loadData();
  }

  private onChangeSort({ prop, order }: any) {
    if (!prop) {
      this.condition.sort = 'updateDate descending';
    } else {
      this.condition.sort = `${prop} ${order}`;
    }
    this.loadData();
  }

  private onPageSizeChange(val: number) {
    this.condition.perPage = val;
  }

  private onRowClick(row: Chat) {
    this.$router.push({
      name: 'ChatMessageView',
      params: {
        tutorId: row.tutorId,
        studentId: row.studentId
      }
    });
  }

  private onCreateChat() {
    this.studentSelectVisible = true;
  }

  private async onSubmitSelectedStudent(args: StudentSelectedArgs) {
    const selectedStudent = args.selectedStudent;

    if (!selectedStudent) {
        this.$alert('生徒の選択がありませんでした', '', {
          type: 'error',
          confirmButtonText: 'OK',
        });
    } else {
      this.$router.push({
        name: 'ChatMessageView',
        params: {
          tutorId: this.accountId,
          studentId: selectedStudent.id,
        }
      });
    }
  }

}
